import { InjectionToken } from '@angular/core';
import { GenericStorageService } from '../../services/storage/generic-storage.service';
import { LocalUserDataMap } from '../../types/interfaces/local-user-data.interface';

export const LOCAL_USER_DATA_STORAGE = new InjectionToken<GenericStorageService<LocalUserDataMap>>(
	'Local user data storage',
);
